import { FC } from 'react';
import { Container } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Button, Label } from '../../atoms';
import BaseTemplate from '../BaseTemplate';
import { LandscapesResponseV3Dto } from '../../../store/landscapeAPI/landscape/dto/response/landscapes-response-v3.dto';
import { SortConfig } from '../../../utils/types/types';
import { LandscapesOrganism } from '../../organisms';
import styles from './LandscapesTemplate.module.css';

export interface LandscapesTemplateProps {
  data: LandscapesResponseV3Dto['data'];
  handleLandscapeClick: (id: string) => void;
  sortConfig: SortConfig;
  setSortConfig: (value: SortConfig) => void;
}

const LandscapesTemplate: FC<LandscapesTemplateProps> = ({
  data,
  handleLandscapeClick,
  sortConfig,
  setSortConfig,
}) => {
  const navigate = useNavigate();
  return (
    <BaseTemplate>
      <Container>
        <div className={styles.heading}>
          <Label content="Landscapes" size="lg" />
          <Button
            variant="dark"
            onClick={() => navigate('/landscapes/add/basic-information')}
          >
            Create New
          </Button>
        </div>
        <LandscapesOrganism
          data={data}
          handleLandscapeClick={handleLandscapeClick}
          sortConfig={sortConfig}
          setSortConfig={setSortConfig}
        />
      </Container>
    </BaseTemplate>
  );
};

export default LandscapesTemplate;
